export default "__VITE_ASSET__uCp1EoMZ__"